import { render } from "./TestAstrologyAPI.vue?vue&type=template&id=0adcabb7&scoped=true"
import script from "./TestAstrologyAPI.vue?vue&type=script&lang=js"
export * from "./TestAstrologyAPI.vue?vue&type=script&lang=js"

import "./TestAstrologyAPI.vue?vue&type=style&index=0&id=0adcabb7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adcabb7"]])

export default __exports__